const posts = [
  {
    id: 1,
    title: 'Cancún: el viaje que superó todas mis expectativas',
    description:
      'Desde el primer día fue una experiencia increíble. Playas de agua turquesa, excelente hotel y una organización impecable. Cancún no es solo fiesta, es descanso, lujo y recuerdos que se quedan para siempre.',
    imageUrl: '/Blog/Cancun.jfif',
    date: 'Ene 22, 2025',
    datetime: '2025-01-22',
    author: {
      name: 'Andrea López',
      imageUrl: '/Blog/Cancun.jfif',
    },
  },
  {
    id: 2,
    title: 'República Dominicana: sol, sabor y pura felicidad',
    description:
      'Este viaje fue simplemente perfecto. La calidez de su gente, las playas infinitas y el ritmo caribeño hacen que quieras quedarte para siempre. Ideal para desconectarse y disfrutar sin preocupaciones.',
    imageUrl: '/Blog/RepublicaDominicana.jfif',
    date: 'Feb 5, 2025',
    datetime: '2025-02-05',
    author: {
      name: 'Carlos Méndez',
      imageUrl: '/Blog/RepublicaDominicana.jfif',
    },
  },
  {
    id: 3,
    title: 'Colombia: colores, cultura y momentos inolvidables',
    description:
      'Colombia me sorprendió en todo sentido. La comida, la historia, la música y cada rincón lleno de vida. Un destino que te abraza y te deja con ganas de volver una y otra vez.',
    imageUrl: '/Blog/Colombia.jfif',
    date: 'Mar 1, 2025',
    datetime: '2025-03-01',
    author: {
      name: 'María Fernanda Ruiz',
      imageUrl: '/Blog/Colombia.jfif',
    },
  },
]

export default function Blog() {
  return (
    <div className="bg-white py-8 sm:py-12">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            ¡Historias reales de viajeros felices!
          </h2>
          <p className="mt-2 text-lg/8 text-gray-600">
            Descubre las experiencias de quienes ya viajaron con nosotros y vivieron momentos inolvidables en cada destino.
          </p>
        </div>
        <div className="mx-auto mt-16 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {posts.map((post) => (
            <article
              key={post.id}
              className="relative isolate flex flex-col justify-end overflow-hidden rounded-2xl bg-gray-900 px-8 pb-8 pt-80 sm:pt-48 lg:pt-80"
            >
              <img alt="" src={post.imageUrl} className="absolute inset-0 -z-10 size-full object-cover" />
              <div className="absolute inset-0 -z-10 bg-gradient-to-t from-gray-900 via-gray-900/40" />
              <div className="absolute inset-0 -z-10 rounded-2xl ring-1 ring-inset ring-gray-900/10" />

              <div className="flex flex-wrap items-center gap-y-1 overflow-hidden text-sm/6 text-gray-300">
                <time dateTime={post.datetime} className="mr-8">
                  {post.date}
                </time>
                <div className="-ml-4 flex items-center gap-x-4">
                  <svg viewBox="0 0 2 2" className="-ml-0.5 size-0.5 flex-none fill-white/50">
                    <circle r={1} cx={1} cy={1} />
                  </svg>
                  <div className="flex gap-x-2.5">
                    <img alt="" src={post.author.imageUrl} className="size-6 flex-none rounded-full bg-white/10" />
                    {post.author.name}
                  </div>
                </div>
              </div>
              <h3 className="mt-3 text-lg/6 font-semibold text-white">
                <a href={post.href}>
                  <span className="absolute inset-0" />
                  {post.title}
                </a>
              </h3>
            </article>
          ))}
        </div>
      </div>
    </div>
  )
}
